import React from "react";
import PropTypes from "prop-types";
import { Button } from "@vitalsource/vstui";

const ButtonGroup = ({ buttons, onChange }) => (
  <span className="button-group">
    {buttons.map((button, index) => {
      const { araiLabel, key, label, ...other } = button;
      let className = "";
      if (index === 0) {
        className = "--first";
      } else if (index === buttons.length - 1) {
        className = "--last";
      }

      if (button.selected) {
        className += " --selected";
      }

      return (
        <Button
          className={className}
          description={button.ariaLabel}
          key={button.key}
          label={button.ariaLabel}
          outline
          onClick={() => onChange(button.value)}
          size="small"
          {...other}
        >
          {button.label}
        </Button>
      );
    })}
  </span>
);

ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      ariaLabel: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired
    })
  ),
  onChange: PropTypes.func.isRequired
};

ButtonGroup.defaultProps = {
  onChange: () => {}
};

export default ButtonGroup;
